import { Component, ElementRef, forwardRef, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseReCaptchaComponentDirective } from './base-re-captcha-component.directive';
import { Parameters, ReCaptchaType, Size, Theme } from '@core/recaptcha/data-access';

@Component({
  selector: 'core-feature-recaptcha',
  standalone: true,
  imports: [],
  template: '<div #captchaWrapperElem></div>',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RecaptchaComponent),
      multi: true,
    },
  ],
})
export class RecaptchaComponent extends BaseReCaptchaComponentDirective implements OnChanges, OnDestroy {
  /**
   * Name of the global expiry callback
   */
  readonly windowOnErrorCallbackProperty = 'ngx_captcha_error_callback';

  /**
   * Name of the global error callback
   */
  readonly windowOnExpireCallbackProperty = 'ngx_captcha_expire_callback';

  recaptchaType: ReCaptchaType = ReCaptchaType.ReCaptcha2;

  /**
   * Theme
   */
  @Input() theme: Theme = 'light';

  /**
   * Size
   */
  @Input() size: Size = 'normal';

  @ViewChild('captchaWrapperElem', { static: false }) captchaWrapperElem!: ElementRef;

  ngOnDestroy(): void {
    window[this.windowOnErrorCallbackProperty] = {};
    window[this.windowOnExpireCallbackProperty] = {};
  }

  captchaSpecificSetup(): void {
    this.registerCallbacks();
  }

  /**
   * Gets reCaptcha properties
   */
  getCaptchaProperties(): Parameters {
    return {
      callback: (response: string) => this.zone.run(() => this.handleCallback(response)),
      'error-callback': () => this.zone.run(() => this.handleErrorCallback()),
      'expired-callback': () => this.zone.run(() => this.handleExpireCallback()),
      sitekey: this.siteKey,
      size: this.size,
      tabindex: this.tabIndex,
      theme: this.theme,
      type: this.type,
    };
  }

  /**
   * Registers global callbacks
   */
  private registerCallbacks(): void {
    window[this.windowOnErrorCallbackProperty] = super.handleErrorCallback.bind(this);
    window[this.windowOnExpireCallbackProperty] = super.handleExpireCallback.bind(this);
  }
}
